import { useCurrentWebsite } from "./useCurrentWebsite";
import {
  isRestrictedInventoryState,
  isRestrictedInventoryAddress,
  restrictedInventoryStateMessage,
} from "@/helpers/inventoryLocationRestrictions";

/**
 * Gitcha public app only. MLS tenants define their own territory in
 * tenant.locationRestriction and some legitimately cover California -
 * Momentum (Kingman, AZ) serves AZ/CA/NV - so this must never reach a BLS
 * domain. Applies to hosting inventory; want-listings and search are exempt.
 */
export const useInventoryLocationRestrictions = () => {
  const { isGitchaDefaultWebsite } = useCurrentWebsite();

  return {
    isRestrictedState: (state) =>
      isGitchaDefaultWebsite && isRestrictedInventoryState(state),
    isRestrictedAddress: (address) =>
      isGitchaDefaultWebsite && isRestrictedInventoryAddress(address),
    restrictionMessage: restrictedInventoryStateMessage,
  };
};

export default useInventoryLocationRestrictions;
